import { YES_NO_TYPES } from "~/common/utils/consultations/intake/data/intakeQuestionsData";
import { HighSchoolDetail } from "~/providers/utils/types/rawResponsesTypes";

export const formatHighSchoolAnswers = (answer: HighSchoolDetail[]) =>
  answer.map(
    ({ did_you_attend, graduation_year, what_kind_of_student_were }) => {
      if (did_you_attend === YES_NO_TYPES.no) {
        return did_you_attend;
      }

      if (!graduation_year) {
        return `${did_you_attend}, ${what_kind_of_student_were}`;
      }

      return `${did_you_attend}, ${graduation_year}, ${what_kind_of_student_were}`;
    },
  );
